import BaseChannelSerializer from '@square/dashboard-data/serializers/channels/base-channel-serializer';
export default class Waitlist extends BaseChannelSerializer {
  modelNameFromPayloadKey() {
    return 'channels/waitlist';
  }
}